// extracted by mini-css-extract-plugin
export default {"collectionContainer__container":"BoxCollection_collectionContainer__container__t5wKX"};